/**
 * @deprecated This export is considered deprecated and will be removed in v4.
 * To learn how to migrate visit: https://chameleondesignsystem.com/resources/migrations/core-v3/
 * */
export const animations = {
    transitionDelay0: 0,
    transitionDelay250: 250,
};
/**
 * @deprecated This export is considered deprecated and will be removed in v4.
 * To learn how to migrate visit: https://chameleondesignsystem.com/resources/migrations/core-v3/
 * */
export const animationTokens = {
    'transition-dialog-in': `visibility ${animations.transitionDelay0}s linear ${animations.transitionDelay0}s, opacity ${animations.transitionDelay250}ms ${animations.transitionDelay0}s, transform ${animations.transitionDelay250}ms`,
    'transition-dialog-out': `visibility ${animations.transitionDelay0}s linear ${animations.transitionDelay250}ms, opacity ${animations.transitionDelay250}ms ${animations.transitionDelay0}s, transform ${animations.transitionDelay250}ms`,
};
